import SettingsService from 'services/SettingsService';

class URLListener {
    constructor() {
        this.langSwitchLink = {
            nl: document.querySelector('[data-lang-switch-link][data-lang="nl"]'),
            en: document.querySelector('[data-lang-switch-link][data-lang="en"]'),
            fr: document.querySelector('[data-lang-switch-link][data-lang="fr"]'),
        };

        this.currentLanguage = SettingsService.get('path').currentLanguage;
    }

    init = () => {
        const overrideURL = SettingsService.get('dnsblockurloverride');

        this.updateLangSwitchURLs(
            overrideURL ? window.location.pathname : '',
            window.location.hash,
        );

        window.addEventListener('AngularNavigation', () => {
            this.updateLangSwitchURLs(
                window.location.pathname,
                window.location.hash,
            );
        });
    };

    updateLangSwitchURLs = (currentPath, currentHash) => {
        Object.entries(this.langSwitchLink).forEach(([lang, link]) => {
            if (link && link.getAttribute('href') !== '#') {
                const langPath = link.getAttribute('href');
                const newPath = currentPath
                    ? currentPath.replace(this.currentLanguage, lang)
                    : langPath;

                link.setAttribute('href', `${newPath}${currentHash}`);
            }
        });
    }
}

export default URLListener;
